/**
 * Created by shubham on 11/4/18.
 */

import {AdminListPage} from "./adminList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class AdminListPageData<T> {
    data = new Array<T>();
    page = new AdminListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminList-datatable/adminList-page-data.ts